export default function DownArrowIcon() {
  // Triangle icons from https://svgbox.net/iconset/octicons
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="5.68 8.5 12.62 6.82"
      className="p-1"
    >
      <path d="M11.646 15.146L5.854 9.354a.5.5 0 01.353-.854h11.586a.5.5 0 01.353.854l-5.793 5.792a.5.5 0 01-.707 0z"></path>
    </svg>
  );
}
